import Titlebar from "../layout/titlebar";
import Lang from "../../userPreferences/staticWords";
import { useEffect, useState } from "react";
import DiscussionCard from "./discussionCard";
import Paginate from "../layout/paginate";
import { resolver } from "../../API/middlewares/resolveRequests";
import {
  addPost,
  searchAllPosts,
} from "./../../API/store/actions/discussion/discussion";
import { useFormik } from "formik";
import { formikSetup, validationSchema } from "../tasks/formikValidation";
import { initialValues } from "./../tasks/formikValidation";
import { useSelector } from "react-redux";
import { englishDate, objToFormData, ScrollToTop } from "../../algorithms";
import CardWithTitleAndIcon from "../reusableComponents/cardWithTitleButton";
import DisccusionForm from "./discussionForm";
import {
  customStyle,
  styleEnd,
  styleStart,
} from "../../algorithms/styleDirection";
import DateInput from "../sharedComponents/datesInputs/date";
import TextInput from "../sharedComponents/inputs/textInput";
import Slide from "react-reveal/Slide";
import LoadingPopup from "../layout/loadingPopup";

const DiscussionIndex = ({ userToken }) => {
  const userLogged = useSelector((state) => state.login.userData);
  const communityId = useSelector((state) => state.community.communityId?.id);

  const submit = async (values) => {
    values.MemberId = parseInt(userLogged?.memberId);
    values.CommunityId = communityId;
    let data = objToFormData(values);
    let res = await addPost(data, userToken);
  };
  const formik = useFormik(
    formikSetup(initialValues, undefined, validationSchema, "posts", submit),
  );
  const { values, handleChange, setFieldValue, touched, errors, handleSubmit } =
    formik;
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState(1);
  const [showComments, setShowComments] = useState({});

  const [show, setShow] = useState(false);
  const onShow = () => {
    setShow(true);
  };
  const [procAdded, setProcAdded] = useState(false);

  const renderModal = () => {
    return (
      <DisccusionForm
        userLogged={userLogged}
        userToken={userToken}
        communityId={communityId} //when we put communities
        setProcAdded={setProcAdded}
        procAdded={procAdded}
        show={show}
        onHide={() => setShow(false)}
      />
    );
  };

  const [searchText, setSearchText] = useState("");
  const [StartDate, setStartDate] = useState("");
  const [EndDate, setEndDate] = useState("");
  const [startDateError, setStartDateError] = useState(false);
  const [endDateError, setEndDateError] = useState(false);
  // const [membersSearch, setMembersSearch] = useState(null);
  // const dispatch = useDispatch();
  // const allMembers = useSelector((state) => state.workTeams.getAllWorkTeams);

  useEffect(() => {
    // dispatch(getAllWorkTeamsAPI(communityId, 1, allMembers?.count, userToken));
    resolver(
      searchAllPosts,
      setData,
      communityId,
      currentPage,
      5,
      {
        name: searchText ? searchText : null,
        startDate: StartDate ? englishDate(StartDate) : null,
        endDate: EndDate ? englishDate(EndDate) : null,
        // memberId: membersSearch ? membersSearch : null,
      },
      userToken,
    );
    ScrollToTop();
  }, [
    currentPage,
    communityId,
    procAdded,
    searchText,
    StartDate,
    EndDate,
    // membersSearch,
  ]);
  const [showSearch, setShowSearch] = useState(false);
  const [showBullets, setShowBullets] = useState({ id: null, display: false });

  if (data)
    return (
      <div className="d-flex flex-column w-100">
        <Titlebar
          title={Lang.discussionCirclesNavTab}
          customImage={"/assets/images/icons/fi-br-comments.png"}
        />

        <div className="d-flex justify-content-center col-12">
          {/* small screens button */}
          <CardWithTitleAndIcon
            containerStyle="d-lg-none d-flex justify-content-center align-items-center mt-4 align-self-center"
            borderColor={"rgba(68, 68, 68, 0.25)"}
            height={90}
            width={200}
            onClick={() => {
              onShow();
            }}
            customImage={"/assets/images/Group 8274.png"}
            imgHeight={50}
            imgWidth={60}
            containerImgHeight={50}
            containerImgWidth={60}
            cardTitle={Lang.addDiscuss}
            boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
          />

          <div
            className={`d-lg-none d-flex justify-content-center align-items-center mx-5 mt-4`}
            style={{ zIndex: 10 }}
            title={"بحث"}
          >
            <div
              className={`mx-2 d-flex justify-content-center align-items-center ${
                showSearch == true ? "backgroundEffect" : "bg-white"
              }`}
              style={{
                border: "1px solid rgba(199, 199, 201, 1)",
                borderRadius: "50%",
                height: 40,
                width: 40,
                cursor: "pointer",
              }}
              onClick={() => {
                setShowSearch(!showSearch);
              }}
            >
              <img
                className={`${showSearch == true ? "filterEffect" : ""}`}
                src="/assets/images/filter.svg"
                width={20}
                height={20}
                alt=""
              />
            </div>
          </div>
        </div>

        <div
          className={`d-lg-flex d-none col justify-content-end my-2 my-md-0 ${customStyle(
            "filterIconFiles",
          )}`}
          style={{ zIndex: 10 }}
          title={"بحث"}
        >
          <div
            className={`mx-2 d-flex justify-content-center align-items-center ${
              showSearch == true ? "backgroundEffect" : "bg-white"
            }`}
            style={{
              border: "1px solid rgba(199, 199, 201, 1)",
              borderRadius: "50%",
              height: 40,
              width: 40,
              cursor: "pointer",
              zIndex: 10,
            }}
            onClick={() => {
              setShowSearch(!showSearch);
            }}
          >
            <img
              className={`${showSearch == true ? "filterEffect" : ""}`}
              src="/assets/images/icons/filter.svg"
              width={20}
              height={20}
              alt=""
            />
          </div>
        </div>
        {showSearch && (
          <Slide left opposite collapse when={showSearch}>
            <div
              className={`d-flex flex-column ${styleStart(
                "p",
                4,
                "md",
              )} justify-content-center justify-content-lg-start align-items-center align-items-lg-start mt-4 align-items-center`}
            >
              <div className="d-flex flex-lg-row flex-column col-lg-8 col-10">
                <TextInput
                  value={searchText}
                  iconName={"search"}
                  iconSize={16}
                  style={{ padding: "21px" }}
                  iconPrefix={"fas"}
                  hiddenPlaceholder={"النقاش"}
                  type={"text"}
                  containerStyle={"col-lg-6 col-12 mb-3 ms-3"}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                    setCurrentPage(1);
                  }}
                />

                <div className="d-flex col-12 col-lg-6 flex-lg-row flex-column align-items-center align-items-lg-start mt-0 px-0">
                  <div
                    className={`col-12 mb-3 mb-lg-0 col-lg-6 ${styleEnd(
                      "p",
                      3,
                      "lg",
                    )}`}
                  >
                    <div className="col-12 align-items-center align-items-xl-start">
                      <DateInput
                        errorMessage={
                          startDateError === true ? Lang.invalidDate : null
                        }
                        style={{ padding: "21px" }}
                        placeholder={Lang.from}
                        containerStyle={"col-12"}
                        name={"StartDate"}
                        value={StartDate}
                        onChange={(e) => {
                          if (e) {
                            setStartDate(e);
                            if (!EndDate || (EndDate && e <= EndDate)) {
                              setStartDateError(false);
                              setEndDateError(false);
                            } else {
                              setStartDateError(true);
                            }
                          }
                        }}
                        onIconClick={() => {
                          if (StartDate != "") {
                            setStartDate("");
                            setStartDateError(false);
                          }
                        }}
                        iconPrefix={StartDate == "" ? "far" : "fas"}
                        iconName={StartDate == "" ? "calendar" : "times"}
                        iconSize={22}
                      />
                    </div>
                    {/* {startDateError === true ? (
                  <div>
                    <p className="my-2 text-danger">{Lang.invalidDate}</p>
                  </div>
                ) : null} */}
                  </div>

                  <div className={`col-12 mb-3 mb-lg-0 col-lg-6 `}>
                    <div className="col-12 align-items-center">
                      <DateInput
                        errorMessage={
                          endDateError === true ? Lang.invalidDate : null
                        }
                        placeholder={Lang.to}
                        containerStyle={"col-12"}
                        style={{ padding: "21px" }}
                        value={EndDate}
                        onChange={(e) => {
                          if (e) {
                            setEndDate(e);
                            if (!StartDate || (StartDate && e >= StartDate)) {
                              setEndDateError(false);
                              setStartDateError(false);
                            } else {
                              setEndDateError(true);
                            }
                          }
                        }}
                        onIconClick={() => {
                          if (EndDate != "") {
                            setEndDate("");
                            setEndDateError(false);
                          } else return null;
                        }}
                        iconPrefix={EndDate == "" ? "far" : "fas"}
                        iconName={EndDate == "" ? "calendar" : "times"}
                        iconSize={22}
                      />
                    </div>
                  </div>
                  {/* {endDateError === true ? (
                <div>
                  <p className="my-2 text-danger">{Lang.invalidDate}</p>
                </div>
              ) : null} */}
                </div>
              </div>

              {/* <div className="d-flex flex-lg-row flex-column col-lg-8 col-11">
          <DropDownList
            field={{ text: "memberName", value: "memberId" }}
            placeholder={Lang.Members}
            border={true}
            containerStyle={`col-12 mb-3 mb-lg-0 col-lg-6 `}
            dataSource={allMembers?.data}
            change={(e) => {
              setCurrentPage(1);
              setMembersSearch(e.value);
            }}
          />
        </div> */}
            </div>
          </Slide>
        )}

        {searchText ? (
          <div
            className={`d-flex ${styleStart(
              "p",
              5,
              "md",
            )} justify-content-center justify-content-lg-start mt-3 align-items-center `}
          >
            <span className=" fw-bold">نتائج البحث عن</span>: {searchText}{" "}
          </div>
        ) : null}
        {/* search Input End */}

        {/* <div className=" d-flex  col-7 justify-content-center ">
        <div
          className="mx-3"
          style={{
            color: active == 1 ? "blue" : "grey",
            borderBottom: active == 1 ? "solid 2px blue" : "none",
          }}
        >
          اطرح قضية للنقاش
        </div>
        <div className="mx-3" style={{ color: active == 2 ? "blue" : "grey" }}>
          استطلاع رأي سريع
        </div>
        <hr />
      </div> */}
        <div className="d-flex flex-lg-row flex-column-reverse flex-wrap align-items-center">
          <div
            className={`d-flex flex-column align-self-center col-lg-8 col-10 ${styleStart(
              "m",
              4,
              "lg",
            )} mx-0`}
          >
            {data?.data?.map((item, index) => {
              return (
                <DiscussionCard
                  key={index}
                  userToken={userToken}
                  userLogged={userLogged}
                  item={item}
                  index={index}
                  showComments={showComments}
                  setShowComments={setShowComments}
                  setProcAdded={setProcAdded}
                  procAdded={procAdded}
                  show={showBullets}
                  setshow={setShowBullets}
                />
              );
            })}
          </div>
          <CardWithTitleAndIcon
            containerStyle={`d-lg-flex d-none flex-column m-lg-auto align-self-center justify-content-center align-items-center col-lg-4 position-fixed ${customStyle(
              "createTaskButton",
            )}`}
            borderColor={"rgba(68, 68, 68, 0.25)"}
            height={180}
            width={180}
            onClick={() => {
              onShow();
            }}
            customImage={"/assets/images/Group 8274.png"}
            imgHeight={70}
            imgWidth={80}
            containerImgHeight={70}
            containerImgWidth={80}
            cardTitle={Lang.addDiscuss}
            boxShadow={"4px 4px 8px 0px rgb(0 0 0 / 20%)"}
          />
        </div>
        {data?.data?.length > 0 ? (
          <Paginate
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            pageCount={Math.ceil(data.count / 5)}
          />
        ) : (
          <div className="text-center container m-5">لا يوجد نقاشات</div>
        )}
        {renderModal()}
      </div>
    );
  return <LoadingPopup show={true} />;
};

export default DiscussionIndex;
